import myApp from "../../../main";

const getters = {
  dashboardWidgets: (state) => {
    const results = state.panelWidgets || [];
    const widgets = [];
    results.forEach((data) => {
      const foundIndex = state.disableWidgets.findIndex((d) => d.id == data.id);
      const isEnable = foundIndex !== -1 && data.id === state.disableWidgets[foundIndex].id ? state.disableWidgets[foundIndex].isShow : true
      const isShow = { isShow: isEnable };
      const widget = { ...data, ...isShow };
      if (getWidgetPermission(widget.widgetType)) {
        widgets.push(widget);
      }
    });
    return widgets ?? [];
  },
  defaultWidget: (state) => {
    const data = state.defaultPanelWidgets;
    return data;
  },
  getDisableWidgets: (state) => {
    const data = state.disableWidgets;
    return data;
  },
  diableCount: (state) => {
    const panelObj = state.panelWidgets.filter(
      (item) => item.isShow === false && item.isDynamicContent != "1"
    );
    return panelObj.length;
  },
  getLastRow: (state) => {
    return state.lastRowIndex;
  },
};

export default getters;

function getWidgetPermission(type) {
  switch (type) {
    // case "upcomingmeetinglist":
    //   return myApp.$security.checkUserAccess("ViewMeeting");
    // case "time":
    //   return myApp.$security.checkUserAccess("ViewMeeting");
    case "upcomingsurveys":
      return myApp.$security.checkUserAccess("ViewSurveyPolls");
    default:
      return true;
  }
}

